import { ScrollParamsType } from './models';

export const DEFAULT_SCROLL_PARAMS: ScrollParamsType = {
  offset: -70,
  ease: 'in-out-sine',
  duration: 500,
  align: 'top',
};
